'use client';
import { LogOut, Settings, SquareArrowOutUpRight, User, UserCog } from 'lucide-react';
import Link from 'next/link';
import { NavigationMenu, NavigationMenuContent, NavigationMenuItem, NavigationMenuLink, NavigationMenuList, NavigationMenuTrigger, } from '../../ui/navigation-menu.jsx';
import { UserAvatar } from '../../ui/user-avatar.jsx';
export var UserNavbarAvatar = function (_a) {
    var user = _a.user;
    return (<UserAvatar firstName={user === null || user === void 0 ? void 0 : user.firstName} lastName={user === null || user === void 0 ? void 0 : user.lastName} avatarUrl={user === null || user === void 0 ? void 0 : user.avatarUrl} className="h-9 w-9" avatarFallbackClassName="bg-black/80 text-secondary dark:bg-white/20 dark:text-white"/>);
};
export var UserNav = function (_a) {
    var logout = _a.logout, userAvatarSlot = _a.userAvatarSlot, _b = _a.settingsUrl, settingsUrl = _b === void 0 ? '/settings' : _b, _c = _a.showAdmin, showAdmin = _c === void 0 ? false : _c, _d = _a.showAccount, showAccount = _d === void 0 ? false : _d, citizenPortalUrl = _a.citizenPortalUrl, governmentPortalUrl = _a.governmentPortalUrl, _e = _a.userMenuLabel, userMenuLabel = _e === void 0 ? 'User menu' : _e;
    return (<NavigationMenu aria-label={userMenuLabel} viewportClassName="lg:absolute lg:right-0 lg:left-auto lg:translate-x-[80px]">
      <NavigationMenuList>
        <NavigationMenuItem className="flex items-center">
          <NavigationMenuTrigger aria-label={userMenuLabel} className="hover:bg-accent focus:bg-accent h-14 rounded-none bg-transparent py-2" triggerMode="click">
            <div className="flex cursor-pointer items-center gap-2">
              {userAvatarSlot !== null && userAvatarSlot !== void 0 ? userAvatarSlot : <UserNavbarAvatar />}
            </div>
          </NavigationMenuTrigger>
          <NavigationMenuContent className="min-w-[200px]">
            <ul className="p-1">
              <li>
                <NavigationMenuLink asChild>
                  <Link href={settingsUrl} className="hover:bg-accent hover:text-accent-foreground flex w-full items-center rounded-md p-2 text-sm">
                    <Settings className="mr-2 h-4 w-4"/>
                    Settings
                  </Link>
                </NavigationMenuLink>
              </li>
              {showAdmin && (<li>
                  <NavigationMenuLink asChild>
                    <Link href="/admin" className="hover:bg-accent hover:text-accent-foreground flex w-full items-center rounded-md p-2 text-sm">
                      <UserCog className="mr-2 h-4 w-4"/>
                      Admin
                    </Link>
                  </NavigationMenuLink>
                </li>)}
              {showAccount && (<li>
                  <NavigationMenuLink asChild>
                    <Link href="/account" className="hover:bg-accent hover:text-accent-foreground flex w-full items-center rounded-md p-2 text-sm">
                      <User className="mr-2 h-4 w-4"/>
                      My Account
                    </Link>
                  </NavigationMenuLink>
                </li>)}
              {citizenPortalUrl && (<li>
                  <NavigationMenuLink asChild>
                    <Link href={citizenPortalUrl} className="hover:bg-accent hover:text-accent-foreground flex w-full items-center rounded-md p-2 text-sm" target="_blank" rel="noopener noreferrer">
                      <SquareArrowOutUpRight className="mr-2 h-4 w-4"/>
                      Public Portal
                    </Link>
                  </NavigationMenuLink>
                </li>)}
              {governmentPortalUrl && (<li>
                  <NavigationMenuLink asChild>
                    <Link href={governmentPortalUrl} className="hover:bg-accent hover:text-accent-foreground flex w-full items-center rounded-md p-2 text-sm">
                      <SquareArrowOutUpRight className="mr-2 h-4 w-4"/>
                      Entity Account
                    </Link>
                  </NavigationMenuLink>
                </li>)}
              <li className="border-border border-t">
                <NavigationMenuLink asChild>
                  <Link href={logout.url} className="flex w-full items-center rounded-md p-2 text-sm text-red-600 hover:bg-red-50 hover:text-red-700 dark:text-red-400 dark:hover:bg-red-950 dark:hover:text-red-300">
                    <LogOut className="mr-2 h-4 w-4"/>
                    {logout.text}
                  </Link>
                </NavigationMenuLink>
              </li>
            </ul>
          </NavigationMenuContent>
        </NavigationMenuItem>
      </NavigationMenuList>
    </NavigationMenu>);
};
